import React from "react";
import { Link } from "react-router-dom";
import { PageHero } from "../components/Section";

export default function Insights() {
  return (
    <div data-testid="insights-page">
      <PageHero
        eyebrow="Insights"
        num="01"
        title={<>Perspectives on <span className="italic text-[var(--bjc-gold)]">AML, financial crime risk,</span> and regulatory developments.</>}
        intro="A curated stream of articles, regulatory commentary, case-based analysis, and thought leadership — by Bharat Jeswani Consulting."
      />

      <section className="bjc-section">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <div className="bjc-card p-12 md:p-24 text-center relative overflow-hidden">
            <div className="absolute inset-0 -z-0 opacity-10 pointer-events-none">
              <div className="absolute -top-40 -left-40 w-[500px] h-[500px] rounded-full bg-[var(--bjc-gold)]/30 blur-[140px]" />
              <div className="absolute -bottom-40 -right-40 w-[500px] h-[500px] rounded-full bg-[var(--bjc-gold)]/20 blur-[140px]" />
            </div>
            <div className="relative">
              <span className="bjc-overline">— Coming Soon</span>
              <h2 className="mt-8 font-serif-display text-4xl md:text-6xl lg:text-7xl leading-[1.02] text-[var(--bjc-text)] max-w-[20ch] mx-auto">
                A considered library is being prepared.
              </h2>
              <p className="mt-8 max-w-2xl mx-auto text-base md:text-lg text-[var(--bjc-text-muted)] leading-relaxed">
                We are publishing slowly and deliberately. The library will include articles,
                regulatory insights, case-based analysis, and thought leadership pieces — each
                written from a practitioner's vantage point.
              </p>

              <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[var(--bjc-border)] border border-[var(--bjc-border)] max-w-3xl mx-auto">
                {["Articles", "Regulatory Insights", "Case-Based Analysis", "Thought Leadership"].map((t, i) => (
                  <div key={t} data-testid={`insight-type-${i}`} className="bg-[var(--bjc-bg)] p-6">
                    <span className="bjc-numeral">— 0{i + 1}</span>
                    <div className="mt-3 font-serif-display text-lg text-[var(--bjc-text)]">{t}</div>
                  </div>
                ))}
              </div>

              <div className="mt-16 flex flex-col sm:flex-row gap-4 justify-center">
                <Link to="/contact" data-testid="insights-cta" className="bjc-btn-primary">
                  Request Early Access
                </Link>
                <Link to="/speaking" data-testid="insights-speaking" className="bjc-btn-secondary">
                  Explore Speaking & Training
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
